import { Outlet } from "react-router-dom";
import Navbar from "@/components/Navbar";
import VerifyBanner from "@/components/VerifyBanner";
import TrialReferralBanner from "@/components/TrialReferralBanner";
import { PublicFooter } from "@/components/Footer";

export default function Layout() {
  return (
    <div className="min-h-screen bg-background">
      <Navbar />
      <div className="lg:pl-64 flex flex-col min-h-screen">
        <VerifyBanner />
        <TrialReferralBanner />
        <main className="max-w-7xl mx-auto w-full px-4 sm:px-6 lg:px-8 py-8 flex-1">
          <Outlet />
        </main>
        <PublicFooter />
      </div>
    </div>
  );
}
